import { createRouter, createWebHistory } from "vue-router";
import HomePage from "../views/HomePage.vue";
import AboutPage from "../views/AboutPage.vue";
import MshelMentorship from "@/views/MshelMentorship.vue";
import MasterclassClub from "@/views/MasterclassClub.vue";
import MshelClub from "@/views/MshelClub.vue";
import MmcRegistrationForm from "@/views/MmcRegistrationForm.vue";
import MremRegistrationForm from "@/views/MremRegistrationForm.vue";
import ContactPage from "@/views/ContactPage.vue";
import ResourcesPage from "@/views/ResourcesPage.vue";
import BumEffect from "@/views/BumEffect.vue";
import MshelGroup from "@/views/MshelGroup.vue";
import HutuAds from "@/views/HutuAds.vue";
import GalleryPage from "@/views/GalleryPage.vue";

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  scrollBehavior() {
    return { top: 0 };
  },
  routes: [
    {
      path: "/",
      name: "home",
      component: HomePage,
    },
    {
      path: "/about",
      name: "about",
      component: AboutPage,
    },
    {
      path: "/mshel-club",
      name: "mshel-club",
      component: MshelClub,
    },
    {
      path: "/bum-masterclass",
      name: "bum-masterclass",
      component: MshelMentorship,
    },
    {
      path: "/bum-masterclass/registration-form/:id",
      name: "mmc-registration-form",
      component: MmcRegistrationForm,
      props: true
    },
    {
      path: "/mrem-masterclass",
      name: "masterclass-club",
      component: MasterclassClub,
    },
    {
      path: "/mrem-masterclass/registration-form/:id",
      name: "mrem-registration-form",
      component: MremRegistrationForm,
      props: true
    },
    {
      path: "/contact",
      name: "contact-us",
      component: ContactPage,
    },
    {
      path: "/resources",
      name: "resources",
      component: ResourcesPage,
    },
    {
      path: "/impact",
      name: "barka-impact",
      component: BumEffect,
    },
    {
      path: "/mshel-group",
      name: "mshel-group",
      component: MshelGroup,
    },
    {
      path: "/hutu-exclusive",
      name: "hutu-exclusive",
      component: HutuAds,
    },
    {
      path: "/gallery",
      name: "gallery",
      component: GalleryPage,
    },
  ],
});

// Track page views in Google Analytics on route change
router.afterEach((to) => {
  if (typeof window.gtag === 'function') {
    window.gtag('config', 'G-C22QGHQ73K', {
      page_path: to.fullPath,
      page_title: to.name
    });
  }
});

export default router;
